import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { api, dt } from "@/lib/api";
import { PageHeader, Card, Table, StatusBadge, AckBadge, Money, Tag } from "@/components/common";
import { useAuth } from "@/context/AuthContext";

const KIND = { warehouse_outlet: ["Gudang → Outlet", "indigo"], outlet_outlet: ["Outlet → Outlet", "amber"], outlet_warehouse: ["Outlet → Gudang", "sky"] };

export default function Transfers() {
  const { can } = useAuth();
  const [rows, setRows] = useState([]);
  const nav = useNavigate();
  useEffect(() => { api.get("/transfers").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <PageHeader title="Transfer stok" sub="Pergerakan fisik sekaligus nilai finansial. Stok asal berkurang & tujuan bertambah begitu tujuan menerima barang.">
        {can("transfer.create", "transfer.outlet") && <Link to="/transfers/new" className="inline-flex items-center gap-1.5 h-9 px-3 rounded-md bg-slate-900 text-white text-sm font-semibold hover:bg-emerald-700" data-testid="new-transfer-button"><Plus size={16} /> Transfer baru</Link>}
      </PageHeader>
      <Card>
        <Table testid="transfers-table" rows={rows} onRow={(r) => nav(`/transfers/${r.id}`)} cols={[
          { h: "Kode", r: (r) => <span className="num text-xs font-semibold text-emerald-700">{r.code}</span> },
          { h: "Jenis", r: (r) => <Tag tone={(KIND[r.kind] || [])[1]}>{(KIND[r.kind] || [r.kind])[0]}</Tag> },
          { h: "Asal", k: "source_name" }, { h: "Tujuan", k: "destination_name" },
          { h: "Item", right: true, r: (r) => r.lines.length },
          { h: "Nilai", right: true, r: (r) => <Money v={r.total_value} className="font-semibold" /> },
          { h: "Pengirim", r: (r) => r.sender?.name || "-" },
          { h: "Status", r: (r) => <span className="flex gap-1 flex-wrap"><StatusBadge s={r.status} />{r.status === "completed" && <AckBadge doc={r} />}{r.discrepancy && <Tag tone="rose">Selisih</Tag>}</span> },
          { h: "Disiapkan", r: (r) => <span className="text-xs text-slate-500">{r.prepared_by?.name} · {dt(r.created_at)}</span> },
        ]} />
      </Card>
    </div>
  );
}
